<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/yanjiusheng">研究生教育</router-link>
    </div>
    <div class="container-width mb50">
      <div class="container-width x-introduce mt50">
        <div class="x-title">研究生教育</div>
        <!-- 科室  -->
        <section class="department-navigation">
          <div class="container-width">
            <ul class="ulPartList">
              <li
                class="li"
                v-for="(item, index) in xuekeData"
                :key="index"
                @click="goXueke(item)"
              >
                <a class="wh_dot">{{ item.name }}</a>
              </li>
            </ul>
            <div class="clear"></div>
          </div>
        </section>
      </div>
    </div>
  </div>
  
</template>
<script>
import service from "../../service/jxky";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "YANJIUSHENG",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/yanjiusheng",
      xuekeData: [],
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      service.getwzGraduateSubList({}, (res) => {
        this.xuekeData = res || [];
      });
    },
    goXueke(e) {
      let articleId = e.id || 0;
      let name = e.name || 0;
      const { href } = this.$router.resolve({
        path: `/jxky/yanjiusheng/xueke`,
        query: {
          id: `${articleId}`,
          xueke: `${name}`,
        },
      });
      window.open(href, "_self");
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
</style>
